<template>
  <div ref="el" class="tooltip-component" :class="{ open: tooltipOpen }" v-bind="$attrs">
    <div
      class="tooltip-component__label"
      aria-describedby="tooltip-demo-content"
      data-tooltip-placeholder
      ref="placeholder"
      @mouseOver.prevent="handleDropdownPosition"
      @touchStart="toggle"
      @click.stop="toggle"
    >
      <slot name="toggle"></slot>
    </div>
    <div class="tooltip-component-dropdown" data-tooltip-dropdown ref="dropdown">
      <div
        role="tooltip"
        id="tooltip-demo-content"
        class="tooltip-component-dropdown__content"
        ref="dropdownContent"
      >
        <slot> </slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, defineProps, defineExpose } from "vue";

const props = defineProps({
  name: { type: String, default: "tooltip" },
});

const tooltipComponentDropdownContentRef = ref<HTMLDivElement>();
const el = ref();
const placeholder = ref();
const dropdown = ref();
const tooltipOpen = ref();
const dropdownContent = ref<HTMLDivElement>();

function handleDropdownPosition() {
  const screenPadding = 16;

  const placeholderRect = placeholder.value?.getBoundingClientRect();
  const dropdownRect = dropdown.value?.getBoundingClientRect();

  const dropdownRightX = dropdownRect.x + dropdownRect.width;
  const placeholderRightX = placeholderRect.x + placeholderRect.width;

  console.log("handleDropdownPosition", {
    dropdownRef: dropdown.value,
    elRef: el.value,
    placeholderRef: placeholder.value,
    placeholderRect,
    dropdownRect,
    dropdownRightX,
    placeholderRightX,
  });

  if (window.innerWidth > 576) {
    if (dropdownRect.x < 0) {
      (dropdown.value as HTMLElement).style.left = "0";
      (dropdown.value as HTMLElement).style.right = "auto";
      (dropdown.value as HTMLElement).style.transform = `translateX(${
        -placeholderRect.x + screenPadding
      }px)`;
    } else if (dropdownRightX > window.outerWidth) {
      (dropdown.value as HTMLElement).style.left = "auto";
      (dropdown.value as HTMLElement).style.right = "0";
      (dropdown.value as HTMLElement).style.transform = `translateX(${
        window.outerWidth - placeholderRightX - screenPadding
      }px)`;
    }
  }

  if (el.value?.classList.contains("xs-bottom-left")) {
    // (dropdownContent.value as HTMLElement).style.right;
  }
}

function toggle() {
  if (tooltipOpen.value === true) {
    close();
  } else {
    open();
  }
}

function open() {
  tooltipOpen.value = true;
  handleDropdownPosition();
}

function close() {
  tooltipOpen.value = false;
}

function handleClickOutside(event: any) {
  if (!(el.value as HTMLElement).contains(event.target)) {
    tooltipOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});
onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

defineExpose({
  el,
  tooltipComponentDropdownContentRef,
});
</script>

<style lang="scss" scoped>
@keyframes tooltipFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

body {
  padding: 16px;
}

.tooltip-component {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
}

.tooltip-component:hover,
.tooltip-component:focus,
.tooltip-component.open {
  z-index: 2;
  height: auto;
}

.tooltip-component__label {
  &:before {
    // for the help cursor
    content: "";
    display: flex;
    cursor: help;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 3;
  }
}

.tooltip-component-dropdown {
  display: none;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  padding-top: 32px;
}

.tooltip-component-dropdown__content {
  border-radius: 4px;
  padding: 8px 12px;
  width: 300px;
  text-align: left;
  background-color: #fff;
  font-size: 0.9rem;
  font-weight: 400;
  color: #767676;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}

.tooltip-component:hover,
.tooltip-component:focus,
.tooltip-component.open {
  .tooltip-component-dropdown {
    animation: tooltipFadeIn 0.15s;
    display: contents;
  }
}

.md-bottom-center {
  .tooltip-component-dropdown__content {
    transform: translateX(-50%);
  }
}

.bottom-left .tooltip-component-dropdown__content {
  transform: translateX(-95%);
  position: absolute;
  top: 100%;
}

@media (hover: hover) {
  .tooltip-component:hover {
    .tooltip-component-dropdown {
      animation: tooltipFadeIn 0.15s;
      display: contents;
    }
  }
}

// large and desktop
@media (min-width: 992px) {
  .tooltip-component {
    width: 0;
  }
  .tooltip-component__label:before {
    width: 1rem;
  }
  .tooltip-component__label {
    width: max-content;
  }
  .tooltip-component-dropdown {
    display: none;
    position: absolute;
    top: 0;
    left: 86%;
    transform: translateX(-50%);
    z-index: 2;
    padding-top: 32px;
    // height: fit-content;
  }

  .tooltip-component-dropdown__content {
    border-radius: 4px;
    padding: 8px 12px;
    width: 300px;
    text-align: left;
    background-color: #fff;
    font-size: 0.9rem;
    font-weight: 400;
    color: #767676;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    // height: fit-content;
  }
}

@media (max-width: 992px) {
  .tooltip-component-component {
    &.right {
      .tooltip-component-dropdown {
        right: 100%;
      }
    }
  }
}
// Mobile devices
@media (max-width: 500px) {
  .tooltip-component-dropdown {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(0%);
    z-index: 2;
    padding-top: 32px;
  }

  .tooltip-component-dropdown__content {
    border-radius: 4px;
    padding: 8px 12px;
    width: 300px;
    text-align: left;
    background-color: #fff;
    font-size: 0.9rem;
    font-weight: 400;
    color: #767676;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  .md-bottom-center .tooltip-component-dropdown__content {
    transform: none;
  }
}

@media (max-width: 500px) {
  .xs-bottom-left {
    .tooltip-component.open {
      .tooltip-component-dropdown__content {
        position: absolute;
        top: 22px;
        right: 0;
        min-width: 120px;
      }
    }
  }

  .bottom-left .tooltip-component-dropdown__content {
    transform: none;
  }

  .tooltip-component-dropdown__content {
    max-width: 50vw;
  }

  .tooltip-component.open {
    &:not(.xs-bottom-center-right-auto) {
      .tooltip-component-dropdown__content {
        top: 22px;
        right: 0;
        min-width: 120px;
        max-width: 50vw;
        position: absolute;
      }
    }
  }

  .tooltip-component:focus,
  .tooltip-component.open {
    &.xs-bottom-center {
      .tooltip-component-dropdown__content {
        position: static;
        top: 22px;
        right: 0;
        min-width: 120px;
      }
    }

    &.xs-bottom-center-right-auto {
      .tooltip-component-dropdown__content {
        right: auto !important;
      }
    }
  }
}

@media (max-width: 500px) {
}
</style>
